import React from 'react';
import { Switch, Route, RouteComponentProps, Redirect } from 'react-router-dom';

import MyIclinicPay from './MyIclinicPay';

export default function IclinicPay({
  match,
}: RouteComponentProps): JSX.Element {
  return (
    <Switch>
      <Route
        exact
        path={`${match.path}/meu-afya-pay`}
        component={MyIclinicPay}
      />
      <Route
        exact
        path={`${match.path}/meu-iclinic-pay`}
        render={() => <Redirect to={`${match.path}/meu-afya-pay`} />}
      />
    </Switch>
  );
}
